(function() {
  'use strict';

  var CartUpsells = {
    selectors: {
      addButton: '[data-upsell-add-to-cart]',
      slider: '.cart-upsells__slider [data-module-slider]',
      swiperContainer: '[data-ref-container]',
      quickview: '[data-upsell-quickview]',
      quickviewClose: '[data-upsell-quickview-close]',
      quickviewImage: '[data-upsell-quickview-image]',
      quickviewTitle: '[data-upsell-quickview-title]',
      quickviewPrice: '[data-upsell-quickview-price]',
      quickviewOptions: '[data-upsell-quickview-options]',
      quickviewAdd: '[data-upsell-quickview-add]'
    },

    currentProduct: null,
    selectedVariant: null,

    init: function() {
      this.bindEvents();
      this.initSliders();
    },

    bindEvents: function() {
      var self = this;

      // Handle upsell add-to-cart button clicks (delegated)
      $(document).on('click', this.selectors.addButton, function(e) {
        self.onAddToCart(e);
      });

      // Quick-view modal events
      $(document).on('click', this.selectors.quickviewClose, function() {
        self.closeQuickView();
      });

      $(document).on('click', this.selectors.quickviewAdd, function() {
        self.onModalAddToCart();
      });

      $(document).on('change', '[data-upsell-quickview-options] select', function() {
        self.onOptionChange();
      });

      // Re-init sliders when cart updates
      $(document).on('cart.requestComplete', function() {
        setTimeout(function() {
          self.initSliders();
        }, 300);
      });

      // Custom variant info popup
      $(document).on('click', '[data-open-custom-variant-popup]', function(e) {
        e.preventDefault();
        $('[data-custom-variant-popup]').show();
      });

      $(document).on('click', '[data-close-custom-variant-popup]', function(e) {
        e.preventDefault();
        $('[data-custom-variant-popup]').hide();
      });
    },

    initSliders: function() {
      console.log('initSliders');
      var sliders = document.querySelectorAll(this.selectors.slider);

      if (sliders.length === 0) {
        return;
      }

      sliders.forEach(function(slider) {
        console.log('initSliders > forEach');
        var container = slider.querySelector('[data-ref-container]');

        if (container && container.swiper) {
          console.log('initSliders > swiper.update()');
          container.swiper.update();
          return;
        }

        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: 'cart' }
        }));
      });
    },

    refreshCart: function(callback) {
      var self = this;

      if (window.rfd && typeof window.rfd.renderCart === 'function') {
        window.rfd.renderCart(true, function() {
          if (window.rfd.enableBtns) {
            window.rfd.enableBtns();
          }
          setTimeout(function() {
            self.initSliders();
            if (callback) callback();
          }, 100);
        });
      } else {
        $(document).trigger('cart.requestComplete');
        if (callback) callback();
      }
    },

    onAddToCart: function(event) {
      event.preventDefault();
      var self = this;
      var button = event.currentTarget;

      // If product has options, open quick-view modal instead
      if (button.dataset.hasOptions === 'true') {
        var handle = button.dataset.productHandle;
        if (handle) {
          self.openQuickView(handle);
        }
        return;
      }

      var variantId = button.dataset.variantId;
      var textElement = button.querySelector('[data-ctrl-text]');
      var addingElement = button.querySelector('[data-ctrl-adding]');
      var addedElement = button.querySelector('[data-ctrl-added]');

      function showState(state) {
        if (textElement) textElement.style.display = state === 'default' ? '' : 'none';
        if (addingElement) addingElement.style.display = state === 'adding' ? '' : 'none';
        if (addedElement) addedElement.style.display = state === 'added' ? '' : 'none';
      }

      button.disabled = true;
      showState('adding');

      this.addToCart(variantId, {}, function() {
        showState('added');
        self.refreshCart();
      }, function() {
        showState('default');
        button.disabled = false;
      });
    },

    addToCart: function(variantId, properties, success, error) {
      // Default properties for tracking upsell items
      properties = properties || {};
      properties['_added_via'] = 'cart_upsell';

      if (window.CartJS) {
        CartJS.addItem(parseInt(variantId, 10), 1, properties, {
          success: function() { if (success) success(); },
          error: function() { if (error) error(); }
        });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: properties
          })
        })
        .then(function(response) {
          if (response.ok) { if (success) success(); }
          else { if (error) error(); }
        })
        .catch(function() { if (error) error(); });
      }
    },

    // Quick-view modal methods
    openQuickView: function(handle) {
      var self = this;
      var modal = document.querySelector(this.selectors.quickview);
      if (!modal) return;

      fetch('/products/' + handle + '.json')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          self.currentProduct = data.product;
          self.populateQuickView(data.product);
          modal.style.display = '';
          document.body.classList.add('is-upsell-quickview-open');
        })
        .catch(function(err) {
          console.error('Failed to load product:', err);
        });
    },

    populateQuickView: function(product) {
      var imageEl = document.querySelector(this.selectors.quickviewImage);
      var titleEl = document.querySelector(this.selectors.quickviewTitle);
      var priceEl = document.querySelector(this.selectors.quickviewPrice);
      var optionsEl = document.querySelector(this.selectors.quickviewOptions);
      var addBtn = document.querySelector(this.selectors.quickviewAdd);

      // Image
      if (imageEl && product.images && product.images.length > 0) {
        imageEl.innerHTML = '<img src="' + product.images[0].src + '" alt="' + product.title + '">';
      }

      // Title
      if (titleEl) {
        titleEl.textContent = product.title;
      }

      // Options
      if (optionsEl) {
        this.renderVariantSelectors(product, optionsEl);
      }

      // Set initial variant and price
      this.selectedVariant = product.variants[0];
      this.updatePrice();

      // Enable add button
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Bag';
      }
    },

    renderVariantSelectors: function(product, container) {
      var html = '';

      product.options.forEach(function(option, index) {
        var optionName = typeof option === 'object' ? option.name : option;
        var values = [];

        // Collect unique values for this option from variants
        product.variants.forEach(function(variant) {
          var val = variant['option' + (index + 1)];
          if (val && values.indexOf(val) === -1) {
            values.push(val);
          }
        });

        html += '<div class="cart-upsell-quickview__option">';
        html += '<label>' + optionName + '</label>';
        html += '<select data-option-index="' + index + '">';
        values.forEach(function(val) {
          html += '<option value="' + val + '">' + val + '</option>';
        });
        html += '</select>';
        html += '</div>';
      });

      container.innerHTML = html;
    },

    onOptionChange: function() {
      if (!this.currentProduct) return;

      var optionsEl = document.querySelector(this.selectors.quickviewOptions);
      var selects = optionsEl.querySelectorAll('select');
      var selectedOptions = [];

      selects.forEach(function(select) {
        selectedOptions.push(select.value);
      });

      // Find matching variant by comparing only the options that exist
      var matched = null;
      var numOptions = selectedOptions.length;
      this.currentProduct.variants.forEach(function(variant) {
        if (matched) return;
        var isMatch = true;
        for (var i = 0; i < numOptions; i++) {
          if (variant['option' + (i + 1)] !== selectedOptions[i]) {
            isMatch = false;
            break;
          }
        }
        if (isMatch) matched = variant;
      });

      this.selectedVariant = matched;
      console.log('Matched variant:', matched);
      console.log('Featured image:', matched ? matched.featured_image : 'no match');
      console.log('All product images:', this.currentProduct.images);
      this.updatePrice();
      this.updateImage();

      // Update add button state
      var addBtn = document.querySelector(this.selectors.quickviewAdd);
      if (addBtn) {
        if (!matched) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Bag';
        }
      }
    },

    updatePrice: function() {
      var priceEl = document.querySelector(this.selectors.quickviewPrice);
      if (!priceEl || !this.selectedVariant) return;

      // /products/{handle}.json returns price as a string like "29.99"
      var price = parseFloat(this.selectedVariant.price).toFixed(2);
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'GBP';
      var symbol = currency === 'GBP' ? '\u00a3' : currency === 'USD' ? '$' : currency === 'EUR' ? '\u20ac' : '';

      priceEl.textContent = symbol + price;
    },

    updateImage: function() {
      var imageEl = document.querySelector(this.selectors.quickviewImage);
      if (!imageEl || !this.currentProduct) return;

      var imgSrc = null;

      // Use variant's image_id to find matching product image
      if (this.selectedVariant && this.selectedVariant.image_id && this.currentProduct.images) {
        var variantImageId = this.selectedVariant.image_id;
        for (var i = 0; i < this.currentProduct.images.length; i++) {
          if (this.currentProduct.images[i].id === variantImageId) {
            imgSrc = this.currentProduct.images[i].src;
            break;
          }
        }
      }

      // Fallback to first product image
      if (!imgSrc && this.currentProduct.images && this.currentProduct.images.length > 0) {
        imgSrc = this.currentProduct.images[0].src;
      }

      if (imgSrc) {
        var img = imageEl.querySelector('img');
        if (img) {
          img.src = imgSrc;
        }
      }
    },

    onModalAddToCart: function() {
      var self = this;

      console.log("onModalAddToCart");

      if (!this.selectedVariant) {
        console.log("onModalAddToCart no selected variant");
        console.log(this.selectedVariant);
        return;
      }
      var addBtn = document.querySelector(this.selectors.quickviewAdd);
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      this.addToCart(this.selectedVariant.id, {}, function() {
        self.closeQuickView();
        self.refreshCart();
      }, function() {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Bag';
        }
      });
    },

    closeQuickView: function() {
      var modal = document.querySelector(this.selectors.quickview);
      if (modal) {
        modal.style.display = 'none';
      }
      document.body.classList.remove('is-upsell-quickview-open');
      this.currentProduct = null;
      this.selectedVariant = null;
    }
  };

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      CartUpsells.init();
    });
  } else {
    CartUpsells.init();
  }

  // Expose for external access
  window.CartUpsells = CartUpsells;

})();
